module.exports = __webpack_public_path__ + "static/img/viewAv1.6c8c626e.png";